import * as React from 'react';

import {ClipPath, Defs, G, Path} from 'react-native-svg';

import Icon from './Icon';
import {IconProps} from './type';
import {memo} from 'react';

const AndroidIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <G clipPath="url(#a)">
        <Path
          fill="#100E3A"
          fillRule="evenodd"
          d="M16.667 11.667v4.166a2.5 2.5 0 0 1-2.5 2.5H5.833a2.5 2.5 0 0 1-2.5-2.5v-4.166h13.334ZM10 2.5c1.108 0 2.153.27 3.072.75l.506-.506a.833.833 0 1 1 1.178 1.178l-.292.292a6.651 6.651 0 0 1 2.203 4.953V10H3.333v-.833a6.65 6.65 0 0 1 2.204-4.952l-.293-.292a.834.834 0 0 1 1.178-1.179l.505.505A6.638 6.638 0 0 1 10 2.5ZM7.5 5.833a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm5 0a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z"
          clipRule="evenodd"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h20v20H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};

export default memo(AndroidIcon);
